import { purchaseUpsellHandler } from '../application/purchase-upsell.use-case';
import { upsellRepository } from '../infrastructure/upsell.repository';

export const purchaseUpsell = purchaseUpsellHandler(upsellRepository);
